import api from './api';

export interface Estrategia {
    nint: number;
    disponibilidades?: number | null;
    bancosCtaCte?: number | null;
    clientes?: number | null;
    otrosCreditos?: number | null;
    bienesDeUso?: number | null;
    proveedores?: number | null;
}

const estrategiaService = {
    getEstrategia: async (): Promise<Estrategia[]> => {
        const response = await api.get<Estrategia[]>('/api/Estrategia');
        const data = response.data;
        
        // Si la respuesta es un array directo
        if (Array.isArray(data)) {
            return data;
        }
        
        // Si tiene estructura con items
        if (data && typeof data === 'object' && 'items' in data) {
            return Array.isArray((data as { items: Estrategia[] }).items) ? (data as { items: Estrategia[] }).items : [];
        }
        
        return [];
    },

    getEstrategiaByNint: async (nint: number): Promise<Estrategia | null> => {
        try {
            const estrategias = await estrategiaService.getEstrategia();
            return estrategias.find(e => e.nint === nint) || null;
        } catch (error) {
            console.error('Error al obtener estrategia:', error);
            return null;
        }
    }
};

export default estrategiaService;

